import workspaceQuery from '../../../graphql/queries/sales/ShopifyConfigurationWorkspaceQuery.graphql';
import listQuery from '../../../graphql/queries/sales/ShopifyConfigurationListQuery.graphql';
import instanceQuery from '../../../graphql/queries/sales/ShopifyConfigurationQuery.graphql';
import defaultQuery from '../../../graphql/queries/sales/ShopifyConfigurationDefault.graphql';
import mutationQuery from '../../../graphql/mutations/sales/ShopifyConfigurationMutation.graphql';
import fragment from '../../../graphql/fragments/sales/ShopifyConfigurationFragment.graphql';
import { ALLOW_ADD, ALLOW_EDIT, ALLOW_VIEW } from '../../../utils/OperationPermissions';
import { EntityType } from '../../../@types/entityTypes';

const ShopifyConfiguration: EntityType = {
  type: 'ShopifyConfiguration',
  title: 'Shopify Configurations',
  formTitle: 'Shopify Configuration',
  formUrl: '/Sales/Channel/ShopifyConfig/Details/',
  workspaceUrl: '/Sales/Channel/ShopifyConfig/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'name',
  },
  fragment,
  screenReference: 'SALES_SHOPIFY_CONFIG',
  operations: ALLOW_ADD | ALLOW_EDIT | ALLOW_VIEW,
};

export default ShopifyConfiguration;
